import { Component } from '@nicolas-riciotti/light2';
import Lenis from '../../helpers/Lenis'
import getPosition from '../../helpers/getPosition'
import Tween from '../../helpers/Tween.js';
import isMobile from '../../helpers/isMobile';

export default class BlockPrompt extends Component {

    created() {
        // this.onScroll = this.onScroll.bind(this);
    }

    resize() {
        this.contentHeight = this.$imageInner.clientHeight;
    }

    attached() {
        this.$image = this.querySelector('[prompt-image]');
        this.$imageInner = this.querySelector('[prompt-image-inner]');
        this.$loader = this.querySelector('[prompt-loader]');

        

        this.$send = this.querySelector('[prompt-send]');
        this.$close = this.querySelector('[prompt-close]');
        this.$typeText = this.querySelector('[prompt-type-text]');
        
        this.$originalText = this.querySelector('[prompt-original-text]');
        this.chars = this.$originalText.innerHTML.trim().split('');
        
        this.$send?.addEventListener('click', e => {
            this.generate();
        });
        this.$close?.addEventListener('click', e => {
            this.close();
        });
        this.resize();

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => {
                this.resize();
                requestAnimationFrame(() => {
                    this.resize();
                });
            });
        }
    }

    generate() {
        this.opened = true;
        clearTimeout(this.typeTimer);
        this.$typeText.innerHTML = this.$originalText.innerHTML.trim();
        Tween({e:0}, {
            to: {e:1},
            easing:    [0.43, 0.195, 0.02, 1],
            duration:  1300,
            step: e => {
                this.$image.style.maxHeight = (e * this.contentHeight) + 'px';
            }
        });

        this.$loader.classList.add('is-loading');
        setTimeout(()=>{
            this.$loader.classList.remove('is-loading');
        }, 2000)
    }

    close() {
        this.opened = false;
        Tween({e:0}, {
            to: {e:1},
            easing:    [0.43, 0.195, 0.02, 1],
            duration:  1300,
            step: e => {
                this.$image.style.maxHeight = ((1 - e) * this.contentHeight) + 'px';
            }
        });
    }

    play() {
        clearTimeout(this.typeTimer);
        // Typing animation disabled — original text is visible by default
    }

    typeIn() {
        // no-op
    }

    pause() {
        clearTimeout(this.typeTimer);
        if (this.opened) {
            this.close();
        }
    }
 
}

customElements.define('block-prompt', BlockPrompt);
